/* ================================================================ */
// CELL FIELD EDITOR COMPONENT | CellEditor.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useImperativeHandle, useRef, forwardRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Material UI
import FormControl from '@material-ui/core/FormControl';
import makeStyles from '@material-ui/styles/makeStyles';
// Local Components
import Field from './Field';
/* ========================================== */
// Constants
/* ========================================== */
const FieldTypes = {
    STRING: 'string',
    LATITUDE: 'lat',
    LONGITUDE: 'lon',
    INTEGER: 'int',
    URL: 'url',
    HTML: 'html',
    MEDIA: 'media'
};
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    root: {
        fontSize: '1rem',
        margin: 0,
        position: 'relative'
    }
}));
/* ========================================== */
/**
 * Cell Editor
 * -----------
 * Form wrapper for generic single cell field editing
 * 
 *
 * @component
 * @param {object} props component props
 * @param {string} props.label field label
 * @param {string} props.type field type
 * @param {string} props.value field value
 * @param {func} props.onCommit react data grid commit func
 * @param {object} props.otherProps additional props
 */
const FieldEditor = ({
    label,
    type,
    value,
    onCommit,
    ...otherProps
}, ref) => {
    const classes = useStyles();
    const inputRef = useRef();
    const columnKey = otherProps?.column?.key;
    const [currentValue, setCurrentValue] = useState(value);
    useImperativeHandle(ref, () => ({
        getInputNode() { 
            return inputRef.current; 
        },
        getValue() {
            return {[columnKey]: currentValue};
        }
    }), [inputRef, currentValue, columnKey]);
    const handleChange = (newValue) => {
        console.log(newValue);
        //setCurrentValue(newValue);
    };
    const handleUpdate = (newValue) => {
        console.log(newValue);
        setCurrentValue(newValue);
        //onCommit && onCommit();
    };
    return (
        <FormControl
            margin="dense"
            size="small"
            variant="outlined"
            className={classNames(classes.root/*,'rdg-image-cell-wrapper'*/)}
        > 
            <Field
                ref={inputRef}
                label={label}
                type={type}
                value={value}
                onChange={handleChange}
                onUpdate={handleUpdate}
            />
        </FormControl>
    );
};
/* ======================== */
// PROPS
/* ======================== */
FieldEditor.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(FieldTypes)).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    onCommit: PropTypes.func,
    otherProps: PropTypes.object
};
FieldEditor.displayName = 'FieldEditor';
/* ========================================== */
// Export
/* ========================================== */
export default forwardRef(FieldEditor);